import { FC, ReactNode } from "react";
import usePermissions from "src/hooks/usePermissions/usePermissions";
import type { Permission } from "src/constants/permissions";

interface Props {
	children?: ReactNode;
	requiredPermission?: Permission | string;
}

const UserAdminFilter: FC<Props> = ({ children, requiredPermission }) => {
	const { hasPermission, isLoading } = usePermissions();

	if (isLoading) return null;

	if (requiredPermission) {
		return hasPermission(requiredPermission) ? <>{children}</> : null;
	}

	return <>{children}</>;
};

export default UserAdminFilter;
